import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcReferral = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 32 32"
    {...props}
  >
    <g
      fill="none"
      fillRule="evenodd"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    >
      <path d="m26.333 18.097-8.228 8.23a2.295 2.295 0 0 1-3.248 0L5 16.478V5h11.475l9.858 9.86c.89.895.89 2.341 0 3.237ZM8.99 9h.02" />
    </g>
  </svg>
);
export default SvgIcReferral;
